export const cardData4 = [
  {
    reviewStars: 5,
    text: "Phosfluorescently reinvent prospective metrics before granular schema. Professionally metrics before expedite client-centric methods of empow ment whereas effective solut ion.",
    avatarSrc: "assets/img/testimonial/testi_1_1.jpg",
    name: "Alex Farnandes",
    designation: "UI/UX Designer",
    quoteIconSrc: "assets/img/icon/quote_left.svg",
  },
  {
    reviewStars: 5,
    text: "Dnosflu orescent reinvent prospective metrics before granular schema. Professionally metrics before expedite client-centric methods of empow ment whereas effective coverless.",
    avatarSrc: "assets/img/testimonial/testi_1_2.jpg",
    name: "Mariana Sonia",
    designation: "CEO at Corola",
    quoteIconSrc: "assets/img/icon/quote_left.svg",
  },
  {
    reviewStars: 5,
    text: "The best service reinvent prospective metrics before granular schema. Professionally metrics before expedite client-centric methods of empow ment whereas effective turnings.",
    avatarSrc: "assets/img/testimonial/testi_1_3.jpg",
    name: "Abraham Khalil",
    designation: "UI/UX Designer",
    quoteIconSrc: "assets/img/icon/quote_left.svg",
  },
  {
    reviewStars: 5,
    text: "Five star he reinvent prospective metrics before granular schema. Professionally metrics before expedite client-centric methods of empow ment whereas effective gotoning.",
    avatarSrc: "assets/img/testimonial/testi_1_4.jpg",
    name: "Alexa Jenifer",
    designation: "CEO at Morosto",
    quoteIconSrc: "assets/img/icon/quote_left.svg",
  },
];
